import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'tree-permiso-actividad',
  template: `
  <ul class="list-permisos">
  <li *ngFor="let item of rama">
    <div class=" d-flex justify-content-start " [ngClass]="{'permisos-tree': item.children.length > 0}">
        <div class="border border-bottom-0 p-0 f-11" style="width:350px; min-height:30px" >
          <span [ngStyle]="{'padding-left':(nivel *10).toString()+'px'}"> 
            <i class="ti-angle-double-right" *ngIf="item.children.length > 0" (click)="item.mostrar = !item.mostrar" [hidden]="item.mostrar"></i>
            <i class="ti-angle-double-down" *ngIf="item.children.length > 0" (click)="item.mostrar = !item.mostrar" [hidden]="!item.mostrar"></i>    
            <i class="ti-check" *ngIf="item.children.length == 0"></i>
             {{item.descripcion}}
          </span>
        </div>
        
        <div class=" text-center border border-bottom-0 f-11 p-0" style="width:200px"> {{item.fecha_apertura_secretaria | date:'dd/MM/yyyy  HH:mm'}}</div>
        <div class=" text-center border border-bottom-0 f-11 p-0" style="width:200px">{{item.fecha_cierre_secretaria | date:'dd/MM/yyyy HH:mm'}} </div>
        <div class=" text-center border border-bottom-0 f-11 p-0" style="width:200px">{{item.fecha_apertura_docente | date:'dd/MM/yyyy HH:mm'}} </div>
        <div class=" text-center border border-bottom-0 f-11 p-0" style="width:200px">{{item.fecha_cierre_docente | date:'dd/MM/yyyy HH:mm'}} </div>
        <div class=" text-center border border-bottom-0 f-11 p-0" style="width:200px" *ngIf="idTipo ==1">{{item.fecha_apertura_docente_causa | date:'dd/MM/yyyy HH:mm'}}</div>
        <div class=" text-center border border-bottom-0 f-11 p-0" style="width:200px" *ngIf="idTipo ==1">{{item.fecha_cierre_docente_causa | date:'dd/MM/yyyy HH:mm'}} </div>
        
        <div class=" border border-bottom-0 text-center" style="width:80px">
          <div class="contact-icon m-1">
            <button 
              type="button" 
              *ngIf="item.nodoPapa != null && item.formula == null "
              class="btn btn-warning p-1" 
              [hidden]="!activarBoton('editar')"
              (click)="editar(item)">
                <i class="icofont icofont-ui-edit m-0 f-14 text-white"></i>
            </button>
          </div>
        </div>
    </div>
      <tree-permiso-actividad
        [rama]= "item.children"  
        [botones]="botones" 
        [idTipo]="idTipo"
        *ngIf="item.mostrar" 
        [nivel]="nivel+1"
        [mostrar]="mostrar"
        (emittEditarItem)="editar($event)">
      </tree-permiso-actividad>
  </li>
</ul>
  `,
  styles: []
})
export class TreePermisoActividadComponent implements OnInit {
  @Input() rama
  @Input() idTipo = 1
  @Input() botones = []
  @Input() nivel = 0
  @Input() mostrar = true
  
  
  @Output() emittEditarItem = new EventEmitter()
  constructor() { }

  ngOnInit() {

  }

  ngOnChanges(changes:SimpleChanges) {
    
    if(changes.rama != undefined  && changes.rama.currentValue != undefined && changes.rama.currentValue.length > 0 ){
      if(this.mostrar) this.mostrarTodo(true)
    }
      
  }

  public activarBoton(tipo){
    if(this.botones.length == 0) return false
    if(this.botones.find(x=> x == tipo) != undefined ) return true
    return false
  }

  public editar(item){
    this.emittEditarItem.emit(item)
  }

  public mostrarTodo(valor){
    this.modificarNodosParametro(this.rama,'mostrar',valor, 0)
  }
  private modificarNodosParametro(rama,campo,valor,index){
    if(rama.length > 0){
      let count = 0 
      for(let hijo of rama){
        hijo[campo] = valor
        this.modificarNodosParametro(hijo.children,campo, valor,count)
      }
    }else{
      return null
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/element/tree-permiso-actividad.component.ts